import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5cba4012"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ba-weekly-edit"
};
const _hoisted_2 = {
  class: "ba-weekly-body"
};
const _hoisted_3 = {
  key: 0,
  class: "ba-weekly-body-title ba-text ba-text-purple"
};
const _hoisted_4 = {
  class: "ba-advanced-title"
};
const _hoisted_5 = {
  class: "ba-advanced-body"
};
const _hoisted_6 = {
  class: "ba-weekly-bottom"
};
const _hoisted_7 = {
  class: "ba-weekly-bottom-buttons"
};
const _hoisted_8 = {
  class: "ba-weekly-buttons"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ba-weekly-footer"
}, " The changes will immediately reflect on Amazon Seller Central ", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PpcBudgetAllocationWeeklyBudgetCampaignBody = _resolveComponent("PpcBudgetAllocationWeeklyBudgetCampaignBody");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_ppc_budget_allocation_weekly_budget_campaign = _resolveComponent("ppc-budget-allocation-weekly-budget-campaign");
  const _component_app_button = _resolveComponent("app-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [$props.type !== 'sponsored_brand' ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($props.type === 'discovery' ? 'Discovery' : 'Performance') + " Targeting ", 1)) : _createCommentVNode("", true), _createVNode(_component_PpcBudgetAllocationWeeklyBudgetCampaignBody, {
    data: $props.data,
    open: $props.open,
    country_code: $props.country_code,
    currency: $props.currency,
    budgetCurrent: $data.localModel,
    potential: $data.localModelPotential,
    validationMultiplier: $props.validationMultiplier,
    onUpdate: $options.onInputUpdate
  }, null, 8, ["data", "open", "country_code", "currency", "budgetCurrent", "potential", "validationMultiplier", "onUpdate"])]), $props.type !== 'sponsored_brand' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(["ba-weekly-advanced", {
      advanced: $data.advanced
    }])
  }, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_app_icon, {
    icon: "advanced"
  }), _createElementVNode("div", {
    class: "advanced-title-text",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onAdvancedToggle && $options.onAdvancedToggle(...args))
  }, "Advanced"), _createVNode(_component_app_icon, {
    icon: "chevron-up",
    onClick: $options.onAdvancedToggle,
    class: _normalizeClass(["advanced-toggle", {
      advanced: $data.advanced
    }])
  }, null, 8, ["onClick", "class"])]), _withDirectives(_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.localCampaigns, campaign => {
    return _openBlock(), _createBlock(_component_ppc_budget_allocation_weekly_budget_campaign, {
      key: campaign.id,
      item: campaign,
      currency: $props.currency,
      country_code: $props.country_code,
      mode: $props.mode,
      type: $props.type,
      onUpdateCampaign: $options.onUpdateCampaign,
      style: {
        "width": "100%"
      }
    }, null, 8, ["item", "currency", "country_code", "mode", "type", "onUpdateCampaign"]);
  }), 128))], 512), [[_vShow, $data.advanced]])], 2)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_app_button, {
    v2: "",
    small: "",
    variant: "outline-light",
    onClick: $options.onCancel
  }, {
    default: _withCtx(() => [_createTextVNode("Cancel")]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_app_button, {
    v2: "",
    small: "",
    variant: "success",
    onClick: $options.onApply,
    disabled: $options.applyButtonDisabled
  }, {
    default: _withCtx(() => [_createTextVNode("Apply")]),
    _: 1
  }, 8, ["onClick", "disabled"])])]), _hoisted_9])]);
}